import React from 'react'
import { useTheme } from '@mui/material'
import { IconButton } from '@center/ui-kit'
import { ExpandContainer, ExpandIcon } from './ExpandStyles'
import { useTranslation } from 'react-i18next'
import ControlsTooltipWrapper from '../ControlsTooltipWrapper'

const Expand = ({
  isExpanded = false,
  onToggleExpand = () => {},
  showExpandButton = true,
  ...props
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!showExpandButton) {
    return null
  }

  return (
    <ExpandContainer {...props}>
      <ControlsTooltipWrapper 
        title={isExpanded ? t('cartography.maps.controls.minimize') : t('cartography.maps.controls.expand')} 
        arrow 
        placement='right'
      >
        <ExpandIcon
          onClick={() => {
            onToggleExpand()
          }}
        >
          <i 
            className={`fa-solid ${isExpanded ? 'fa-arrow-down-left-and-arrow-up-right-to-center' : 'fa-arrow-up-right-and-arrow-down-left-from-center'}`}
            style={{ transform: 'scaleX(-1)' }}
          />
        </ExpandIcon>
      </ControlsTooltipWrapper>
    </ExpandContainer>
  )
}

export default Expand